import React from 'react'; // eslint-disable-line no-unused-vars
import { connect } from 'react-redux';
//import * as Session from '../../session'
import CodeLoginFormView from '../components/CodeLoginFormView'
import { currentUser } from '../../reducer';

import { submitCodeLoginForm } from '../actions'

const mapStateToProps = (state) => {
  return {
    // initialValues: {pin: "BZWUPL"},
    current_user_id: currentUser(state).get("id"),
    current_user: currentUser(state)
  }
};

const mapDipatchToProps = (dispatch, ownProps) => {
  return {
    onSubmit: ({pin}) => {
      dispatch(submitCodeLoginForm(pin,window.getCookie("udid")));
    }
  }
}

export const CodeLoginForm = connect(mapStateToProps,mapDipatchToProps)(CodeLoginFormView);

export default CodeLoginForm;



// WEBPACK FOOTER //
// ./src/snapit_app/containers/CodeLoginForm.js